import { Text } from 'foundations-components/components/Text';
import ListingLibEmptyStateCell from 'framework-listing-lib/table/ListingLibEmptyStateCell';
import { jsx as _jsx } from "react/jsx-runtime";
export default function ListingLibStringCell({
  value
}) {
  if (!value) {
    return /*#__PURE__*/_jsx(ListingLibEmptyStateCell, {});
  }
  return /*#__PURE__*/_jsx(Text, {
    textAlign: "start",
    truncate: true,
    "data-test-id": "crm-listing-string-cell",
    children: /*#__PURE__*/_jsx("span", {
      title: `${value}`,
      children: value
    })
  });
}